var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items && _vm.items.length)?_c('div',{staticClass:"products-col"},[(_vm.title)?_c('h2',{staticClass:"products-col__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"products-col__list"},_vm._l((_vm.items),function(item,i){return _c('ProductCardComponent',{key:i,attrs:{"data":item}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }